<template>
	<div>
		<v-dialog v-model="dialog_gstTypes" hide-overlay no-click-animation scrollable persistent content-class="full-height" transition="dialog-bottom-transition">
	      <v-card>
	        <v-card-title noshadow class="dialog_searchbox">
	        	<v-subheader full-width>Select GST Type</v-subheader>
	        </v-card-title>
	        <v-divider></v-divider>
	        <v-card-text dialog-card-content>

	        	<v-list nopadding>
		        	<v-list-tile v-for="(item, index) in gstTypes" :key="index" @click="asignGstType(item)">

			            <v-list-tile-content>
			              <v-list-tile-title>{{item.title}}</v-list-tile-title>
			            </v-list-tile-content>

			            <v-list-tile-action>
					        <v-icon v-if="item.id == selectedGstType">radio_button_checked</v-icon>
					        <v-icon v-else>radio_button_unchecked</v-icon>
			            </v-list-tile-action>

		        	</v-list-tile>
		        </v-list>

	        </v-card-text>
	        <v-divider></v-divider>
	        <v-card-actions>
	        	<v-spacer></v-spacer>
	          <v-btn color="blue darken-1" flat @click.native="$parent.fn_closeDialogWeb">close</v-btn>
	        </v-card-actions>
	      </v-card>
	    </v-dialog>
	</div>
</template>

<script>
	export default{
		props:['gstTypes', 'selectedGstType', 'asignGstType'],
		data(){
			return{
				dialog_gstTypes: false
			}
		},
		methods:{
			openDialogWeb: function () {
				this.dialog_gstTypes = true;
			},
			closeDialogWeb: function () {
				this.dialog_gstTypes = false;
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/masters/forms/ledgers/dialogs/dialog_gst_types.vue